import pinkFlower from "@/assets/images/decor/PinkFlower.svg";
import redFlower from "@/assets/images/decor/RedFlower.svg";
import yellowFlower from "@/assets/images/decor/YellowFlower.svg";
import yellowFlower2 from "@/assets/images/decor/YellowFlower2.svg";
import { LiveMobileViewContainer } from "@/components/slides/editor/LiveMobileViewContainer";
import { GradingTestModal } from "@/components/slides/editor/canvas/GradingTestModal";
import { useAppSelector } from "@/store/hooks";
import type { SoundUnitAudio, WordSlideData } from "@ai-teach/types";
import { useEffect, useMemo, useRef, useState } from "react";
import { AiFillPicture } from "react-icons/ai";
import { IoMic, IoPlay } from "react-icons/io5";

/** Inlined so the fill can follow the slow/idle colour, like TurtleIcon on mobile. */
function TurtleGlyph({ color }: { color: string }) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon
    <svg width="30" height="16" viewBox="0 0 64 34" fill="none" style={{ color }}>
      <path
        d="M21.41 0.94207C23.66 0.21207 26.04 -0.0879131 28.4 0.0220869C30.57 0.152087 32.75 0.55205 34.76 1.42205C34.89 1.48205 35.02 1.56208 35.15 1.64208C34.28 3.02208 33.05 4.17208 31.55 4.83208C29.65 5.72208 27.5101 5.83206 25.4401 5.81206C23.8001 5.76206 22.14 5.72208 20.52 5.39208C19.03 5.09208 17.5601 4.44206 16.4601 3.37206C17.9601 2.30206 19.67 1.52207 21.42 0.94207H21.41Z"
        fill="currentColor"
      />
      <path
        d="M54.1 0.871249C55.72 0.411249 57.4901 0.481239 59.0601 1.11124C60.6901 1.75124 62.1101 2.97127 62.9301 4.52127C63.5901 5.74127 63.85 7.19126 63.62 8.57126C63.35 10.3613 62.27 12.0013 60.76 13.0013C59.19 14.0913 57.1901 14.5012 55.3101 14.2312C54.2701 15.7012 53.36 17.3013 52.01 18.5013C50.77 19.6113 49.24 20.3812 47.62 20.7312C47.49 20.7512 47.37 20.7613 47.24 20.7713C48.3 19.1413 48.58 17.1513 48.65 15.2613C48.66 13.9113 48.55 11.8212 48.65 10.4812C48.65 9.24123 48.7201 8.74124 48.8201 7.49124C48.9201 6.12124 49.35 4.75126 50.17 3.63126C51.11 2.29126 52.55 1.33124 54.11 0.861239M58.55 4.62125C57.68 4.80125 57.14 5.87125 57.53 6.68125C57.85 7.16125 58.41 7.48127 58.97 7.58127C59.93 7.74127 60.74 6.66127 60.48 5.77127C60.28 4.95127 59.37 4.38125 58.54 4.62125H58.55Z"
        fill="currentColor"
      />
      <path
        d="M37.24 3.27079C37.7 3.09079 38.16 3.3508 38.53 3.6008C41.39 5.4908 43.65 8.25078 45.01 11.3908C45.07 11.5608 45.2 11.7208 45.19 11.9008C44.65 13.7308 43.7001 15.5107 42.2001 16.7307C40.1301 18.3907 37.59 19.2808 35.13 20.1908C34.5 20.4408 33.83 20.5408 33.17 20.6508C31.34 20.9608 29.46 20.9308 27.63 20.5808C26.51 20.3508 25.3201 19.8708 24.7001 18.8408C23.9901 17.6408 23.98 16.2008 24.05 14.8608C24.12 13.3208 24.24 11.7808 24.57 10.2708C24.73 9.60079 24.9 8.90078 25.31 8.33078C25.95 7.45078 26.95 6.90077 28 6.69077C30.03 6.28077 32.1301 6.2108 34.0901 5.5308C34.8001 5.3008 35.47 4.9408 36 4.4108C36.43 4.0508 36.76 3.56079 37.24 3.27079Z"
        fill="currentColor"
      />
      <path
        d="M11.3001 8.40204C12.2301 7.17204 13.29 6.04203 14.5 5.08203C16.39 5.49203 18.29 5.91203 20.16 6.39203C21.04 6.66203 22 6.91205 22.65 7.60205C23.24 8.32205 23.17 9.31201 23.24 10.182C23.24 12.342 22.8901 14.4721 22.5901 16.6021C22.4001 17.7821 22.2501 18.962 22.0401 20.132C21.9101 20.882 21.2701 21.642 20.4501 21.552C17.6101 21.482 14.7801 21.362 11.9401 21.162C10.4601 21.052 8.99005 20.912 7.54005 20.622C7.23005 20.552 6.87002 20.582 6.63002 20.332C6.49002 20.082 6.61002 19.792 6.63002 19.532C6.96002 17.382 7.62009 15.292 8.45009 13.282C9.22009 11.552 10.1201 9.87202 11.2901 8.38202L11.3001 8.40204Z"
        fill="currentColor"
      />
      <path
        d="M40.8 19.7325C43.1 18.6825 45.33 17.3725 47.12 15.5625C47.15 17.4925 46.64 19.4525 45.55 21.0625C44.6 22.5225 43.17 23.6025 41.65 24.4025C39.95 25.2825 38.12 25.8825 36.26 26.2625C33.99 26.7125 31.67 26.8625 29.36 26.9725C24.29 27.1725 19.19 27.0025 14.16 26.2725C12.15 25.9725 10.13 25.6225 8.17004 25.0525C5.71004 24.3725 3.24997 23.4625 1.21997 21.8825C0.609971 21.3825 0.09 20.7025 0 19.8925C1.16 20.5525 2.43998 20.9625 3.72998 21.3025C5.82998 21.8225 7.97001 22.2225 10.13 22.4125C11.85 22.6025 13.5801 22.6925 15.3101 22.7625C20.3101 22.9225 25.3301 22.9025 30.3101 22.4725C31.7501 22.3325 33.19 22.1525 34.61 21.8425C36.71 21.2525 38.8201 20.6425 40.8201 19.7325H40.8Z"
        fill="currentColor"
      />
      <path
        d="M46.5 22.0625C46.5 22.0625 46.59 22.0825 46.62 22.0825C47.66 22.8925 48.49 23.9325 49.24 25.0025C50.16 26.4025 50.93 27.9425 51.24 29.5925C51.29 29.8525 51.3401 30.2025 51.0801 30.3725C49.9401 31.1525 48.7 31.7725 47.4 32.2525C46.75 32.4625 46.1 32.6925 45.42 32.7425C44.91 30.1025 43.7201 27.5025 41.6801 25.7025C43.5001 24.8325 45.25 23.6725 46.5 22.0625Z"
        fill="currentColor"
      />
      <path
        d="M34.5501 27.6035C36.5601 27.3735 38.54 26.9034 40.47 26.2734C41.02 27.8534 41.1001 29.5734 40.9401 31.2234C40.8101 31.8834 40.8101 32.6634 40.2701 33.1434C40.0701 33.3634 39.76 33.3435 39.49 33.3535C37.87 33.3535 36.2501 33.3535 34.6301 33.3535C34.4101 33.3335 34.15 33.3834 33.97 33.2234C33.81 33.0834 33.8201 32.8435 33.8801 32.6635C34.2701 31.0035 34.4301 29.3034 34.5601 27.6134L34.5501 27.6035Z"
        fill="currentColor"
      />
      <path
        d="M4.7001 29.0217C5.8501 28.3117 6.97005 27.5117 7.90005 26.5117C8.64005 26.6017 9.36011 26.8317 10.0901 26.9817C11.5601 27.3217 13.04 27.6217 14.52 27.9417C13.7 29.3117 12.83 30.6917 11.6 31.7417C10.39 32.7117 8.85 33.1317 7.35 33.4217C7.05 33.5117 6.80003 33.3017 6.63003 33.0817C5.87003 32.1217 5.15005 31.1217 4.40005 30.1417C4.25005 29.9317 4.04005 29.6817 4.15005 29.4017C4.27005 29.2017 4.51009 29.1317 4.69009 29.0117L4.7001 29.0217Z"
        fill="currentColor"
      />
      <path
        d="M18.51 27.832C20.6 28.062 22.69 28.202 24.8 28.202C24.99 29.742 25.23 31.282 25.67 32.762C25.79 33.052 25.53 33.3721 25.23 33.3521C23.83 33.3421 22.43 33.3521 21.03 33.3521C20.43 33.3021 20.05 32.772 19.79 32.282C19.01 30.922 18.7 29.372 18.52 27.832H18.51Z"
        fill="currentColor"
      />
    </svg>
  );
}

const getMascotPrompts = (word: string) => {
  const label = word.split(" ").length > 3 ? "it" : `"${word}"`;
  return [
    `Give it your best shot! Say ${label}!`,
    `Let me hear you say ${label}!`,
    `Can you say ${label} out loud?`,
    `I'm listening — say ${label}!`,
    `You've got this, try saying ${label}!`,
    `Ready? Go ahead and say ${label}!`,
    `Don't be shy, say ${label}!`,
    `Speak clearly and say ${label}!`,
  ];
};

const SLOW_RATE = 0.7;
type PlaybackMode = "slow" | "all" | null;

/** The ordered clip(s) to play for one syllable: its sound units in sequence, else its single `audioUrl`. */
function soundUnitUrls(item: {
  audioUrl: string;
  soundUnits?: SoundUnitAudio[] | undefined;
}): string[] {
  return item.soundUnits && item.soundUnits.length > 0
    ? item.soundUnits.map((u) => u.audioUrl)
    : [item.audioUrl];
}

export function WordPronunciationLiveMobileView() {
  const { slide } = useAppSelector((state) => state.slideEditor.present);

  const wordSlideData = slide?.slideData as WordSlideData | undefined;
  const word = wordSlideData?.word ?? "";

  const mascotPrompt = useMemo(() => {
    const prompts = getMascotPrompts(word || "it");
    return prompts[Math.floor(Math.random() * prompts.length)];
  }, [word]);

  const audioRef = useRef<HTMLAudioElement | null>(null);
  const queueRef = useRef<string[]>([]);
  const rateRef = useRef(1);
  const [mode, setMode] = useState<PlaybackMode>(null);
  const [isGradingOpen, setIsGradingOpen] = useState(false);

  useEffect(() => () => audioRef.current?.pause(), []);

  const playClip = (src: string) => {
    const a = audioRef.current;
    if (!a) return;
    a.src = src;
    a.defaultPlaybackRate = rateRef.current;
    a.playbackRate = rateRef.current;
    a.play().catch((err) => {
      if (err?.name !== "AbortError") setMode(null);
    });
  };

  const playSequence = (
    urls: (string | null | undefined)[],
    rate: number,
    activeMode: PlaybackMode
  ) => {
    const [first, ...rest] = urls.filter((u): u is string => Boolean(u));
    if (!first || !audioRef.current) return;
    queueRef.current = rest;
    rateRef.current = rate;
    setMode(activeMode);
    playClip(first);
  };

  const handleEnded = () => {
    const next = queueRef.current.shift();
    if (next) playClip(next);
    else setMode(null);
  };

  if (!slide || !wordSlideData) return null;

  const { image, wordAudio, syllableAudios, sentence, sentenceAudio } = wordSlideData;
  const fullSequence = [
    wordAudio?.src,
    ...syllableAudios.flatMap((s) => soundUnitUrls(s)),
    wordAudio?.src,
  ];

  return (
    <LiveMobileViewContainer>
      {/* biome-ignore lint/a11y/useMediaCaption: authoring preview — audio is the content being tested */}
      <audio
        ref={audioRef}
        onEnded={handleEnded}
        onPlaying={() => {
          if (audioRef.current) audioRef.current.playbackRate = rateRef.current;
        }}
      />

      <div className="bg-[#FFFEF7] shadow-card w-full p-3 gap-1 flex flex-col items-center overflow-hidden shrink min-h-0">
        <div
          className="aspect-square relative flex-1 flex items-center justify-center bg-muted overflow-hidden w-[58%]"
          style={{ borderRadius: 30 }}
        >
          {image.src ? (
            <img
              src={image.displaySrc ?? image.src}
              alt={image.src}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center">
                <AiFillPicture className="text-muted-foreground text-lg" />
              </div>
            </div>
          )}
        </div>

        <button
          type="button"
          onClick={() => playSequence([wordAudio?.src], 1, null)}
          className="text-center font-semibold hover:opacity-80 transition-opacity"
          style={{ color: "#2626A5", fontSize: word.split(" ").length > 3 ? 22 : 28 }}
        >
          {word}
        </button>

        {syllableAudios.length > 0 && (
          <div className="flex items-center gap-1 text-lg" style={{ color: "#AFAFAF" }}>
            {syllableAudios.map((item, index) => (
              <span key={`${item.syllable}-${index}`} className="flex items-center gap-1">
                {index > 0 && <span>·</span>}
                <button
                  type="button"
                  onClick={() => playSequence(soundUnitUrls(item), 1, null)}
                  className="hover:text-[#2626A5] transition-colors"
                >
                  {item.syllable}
                </button>
              </span>
            ))}
          </div>
        )}
      </div>

      {sentence && (
        <button
          type="button"
          onClick={() => sentenceAudio?.src && playSequence([sentenceAudio.src], 1, null)}
          className="text-sm italic text-muted-foreground text-center px-4 line-clamp-2 hover:opacity-80 transition-opacity"
        >
          {sentence}
        </button>
      )}

      {/* Turtle (slow) + Play all — matches WordPronunciation.tsx's playAllButton: h50, radius 32,
          0.5px grey border, white, 1:2 width ratio. */}
      <div className="w-full flex justify-center gap-2 px-[5%]">
        <button
          type="button"
          onClick={() => playSequence(fullSequence, SLOW_RATE, "slow")}
          disabled={mode === "slow"}
          className="flex-1 max-w-[240px] h-[50px] rounded-[32px] bg-white flex items-center justify-center shadow-[0_2px_6px_rgba(0,0,0,0.08)] transition-colors enabled:hover:bg-orange-50 disabled:cursor-default"
          style={{ border: "0.5px solid #6b6b6b5f" }}
        >
          <TurtleGlyph color={mode === "slow" ? "#AFAFAF" : "#FFAC27"} />
        </button>
        <button
          type="button"
          onClick={() => playSequence(fullSequence, 1, "all")}
          disabled={mode === "all"}
          className="flex-[2] max-w-[240px] h-[50px] rounded-[32px] bg-white flex items-center justify-center shadow-[0_2px_6px_rgba(0,0,0,0.08)] transition-colors enabled:hover:bg-orange-50 disabled:cursor-default"
          style={{ border: "0.5px solid #6b6b6b5f" }}
        >
          <IoPlay className="text-xl" style={{ color: mode === "all" ? "#AFAFAF" : "#FFAC27" }} />
          <span className="font-bold text-lg mx-2" style={{ color: "#333333" }}>
            Play all
          </span>
        </button>
      </div>

      <div className="flex-1 w-full flex items-start justify-center pt-3">
        <div
          style={{ backgroundColor: "#FFE89F" }}
          className="rounded-[20px] px-4 py-2.5 max-w-[90%] shadow-[0_2px_6px_rgba(0,0,0,0.07)]"
        >
          <p
            className="text-center"
            style={{ color: "#565656", fontWeight: 500, fontSize: 18, lineHeight: "20px" }}
          >
            {mascotPrompt}
          </p>
        </div>
      </div>

      {/* Flower cluster around the mic — matches WordPronunciation.tsx's flowerContainer. */}
      <div className="pointer-events-none absolute inset-x-0 -bottom-6 h-24" style={{ zIndex: 0 }}>
        <img src={redFlower} alt="" className="absolute bottom-0 left-[1%] w-[22%]" />
        <img src={yellowFlower2} alt="" className="absolute bottom-2 left-[22%] w-[9%]" />
        <img src={pinkFlower} alt="" className="absolute bottom-0 right-[19%] w-[11%]" />
        <img src={yellowFlower} alt="" className="absolute bottom-12 -right-10 w-[26%]" />
      </div>

      <button
        type="button"
        onClick={() => setIsGradingOpen(true)}
        className="absolute left-1/2 -translate-x-1/2 bottom-12 z-10 w-20 h-20 rounded-full flex items-center justify-center"
        style={{ background: "linear-gradient(180deg, #FF8500 0%, #FFB800 100%)" }}
      >
        <IoMic className="text-6xl p-2" color="white" />
      </button>

      <GradingTestModal
        isOpen={isGradingOpen}
        onClose={() => setIsGradingOpen(false)}
        fields={[
          { label: "Word", value: word },
          ...(sentence ? [{ label: "Sentence", value: sentence }] : []),
        ]}
        question={sentence || word}
        correctAnswer={word}
        toastId="gradingToastPronunciation"
      />
    </LiveMobileViewContainer>
  );
}
